import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'popup-etiquetas',
  templateUrl: './popup-etiquetas.component.html',
  styles: [],
})
export class PopupEtiquetasComponent {
  etiquetas: string[] = [];
  identifier: string;

  constructor(public activeModal: NgbActiveModal) {}

  cancel() {
    this.activeModal.dismiss();
  }
}
